/* eslint-disable */
export const BUILD_ENV: string = 'stage';
export const BUILD_DEPLOYED_VERSION: string = '1cf3cca7e83177b6aaff8529d3921aca97862038';
